import Modal from "react-native-modal";
import React from "react";

import _ from "lodash";
import moment from "moment";

import {
  Image,
  ScrollView,
  Text,
  TextInput,
  TouchableOpacity,
  View
} from "react-native";
import { WheelPicker } from "react-native-wheel-picker-android";
import { connect } from "react-redux";

import PatientAvatar from "../components/PatientAvatar";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";

import { getBaseUrl, setMedical } from "../helpers/storage";

class MedicalScreen extends React.Component {
  constructor(props) {
    super(props);

    const { height, weight } = this.props.navigation.state.params;

    const heightDecimal = height ? parseInt(height * 10) % 10 : null;
    const heightInteger = height ? parseInt(height) : null;

    const weightDecimal = weight ? parseInt(weight * 10) % 10 : null;
    const weightInteger = weight ? parseInt(weight) : null;

    this.state = {
      bmiContainerWidth: 0,
      heightDecimal,
      heightInteger,
      heightSelectorVisible: false,
      temporaryHeightDecimal: null,
      temporaryHeightInteger: null,
      temporaryWeightDecimal: null,
      temporaryWeightInteger: null,
      weightDecimal,
      weightInteger,
      weightSelectorVisible: false
    };
  }

  async updateProfile() {
    const { token } = this.props;

    const {
      heightDecimal,
      heightInteger,
      weightDecimal,
      weightInteger
    } = this.state;

    const height = heightInteger + heightDecimal / 10;
    const weight = weightInteger + weightDecimal / 10;

    const response = await fetch(getBaseUrl() + "profile/me", {
      body: JSON.stringify({
        patient_height: height,
        patient_weight: weight
      }),
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      method: "PATCH"
    });

    const json = await response.json();

    if (json["status"] === "success") {
      setMedical(height, weight);

      this.props.navigation.goBack();
    }
  }

  render() {
    const { themeColors } = this.props;

    const {
      birthdate,
      cardNumber,
      fullName,
      gender,
      age
    } = this.props.navigation.state.params;

    const {
      bmiContainerWidth,
      heightDecimal,
      heightInteger,
      heightSelectorVisible,
      temporaryHeightDecimal,
      temporaryHeightInteger,
      temporaryWeightDecimal,
      temporaryWeightInteger,
      weightDecimal,
      weightInteger,
      weightSelectorVisible
    } = this.state;

    const ageText = moment(birthdate).isValid() ? moment().diff(birthdate, "years") : age;

    const genderName = gender === "m" ? "Laki-Laki" : "Perempuan";

    const height = heightInteger + heightDecimal / 10;
    const weight = weightInteger + weightDecimal / 10;

    let bmiContainer = null;

    if (height && weight) {
      const bmi = Math.round((weight / Math.pow(height / 100, 2)) * 10) / 10;

      let normalizedBmi = bmi;

      if (bmi < 13.5) {
        normalizedBmi = 13.5;
      }

      if (bmi > 36.5) {
        normalizedBmi = 36.5;
      }

      let color = null;
      let description = null;

      if (bmi >= 30) {
        color = "#E64F4F";
        description = "Kegemukan (Obesitas)";
      } else if (bmi >= 25) {
        color = "#FEA501";
        description = "Kelebihan berat badan";
      } else if (bmi >= 18.5) {
        color = "#5DBE66";
        description = "Normal (Ideal)";
      } else {
        color = "#4695EA";
        description = "Kekurangan berat badan";
      }

      bmiContainer = (
        <>
          <View style={{ flexDirection: "row", marginBottom: 10 }}>
            <Text style={{ color, fontSize: 18, ...fonts.bold }}>{bmi}</Text>
            <Text style={{ color, fontSize: 18, ...fonts.light }}>{" - "}</Text>
            <Text style={{ color, fontSize: 18, ...fonts.regular }}>
              {description}
            </Text>
          </View>
          <View
            onLayout={event =>
              this.setState({
                bmiContainerWidth: event.nativeEvent.layout.width
              })
            }
          >
            <View style={{ flexDirection: "row", height: 100 }}>
              <View
                style={{
                  backgroundColor: "#4695EA",
                  flex: 5,
                  justifyContent: "flex-end"
                }}
              >
                <Text
                  style={{
                    color: staticColors.white,
                    fontSize: 12,
                    padding: 4,

                    ...fonts.bold
                  }}
                >
                  Kurang
                </Text>
              </View>
              <View
                style={{
                  backgroundColor: "#5DBE66",
                  flex: 6.5,
                  justifyContent: "flex-end"
                }}
              >
                <Text
                  style={{
                    color: staticColors.white,
                    fontSize: 12,
                    padding: 4,

                    ...fonts.bold
                  }}
                >
                  Ideal
                </Text>
              </View>
              <View
                style={{
                  backgroundColor: "#FEA501",
                  flex: 5,
                  justifyContent: "flex-end"
                }}
              >
                <Text
                  style={{
                    color: staticColors.white,
                    fontSize: 12,
                    padding: 4,

                    ...fonts.bold
                  }}
                >
                  Lebih
                </Text>
              </View>
              <View
                style={{
                  backgroundColor: "#E64F4F",
                  flex: 6.5,
                  justifyContent: "flex-end"
                }}
              >
                <Text
                  style={{
                    color: staticColors.white,
                    fontSize: 12,
                    padding: 4,

                    ...fonts.bold
                  }}
                >
                  Obesitas
                </Text>
              </View>
            </View>
            <View
              style={{
                alignItems: "center",
                backgroundColor: staticColors.white,
                borderRadius: 10,
                height: 20,
                left: (bmiContainerWidth * (normalizedBmi - 13.5)) / 23 - 10,
                marginTop: 20,
                position: "absolute",
                width: 20
              }}
            />
          </View>
          <View style={{ flexDirection: "row" }}>
            <View style={{ flex: 3.5 }} />
            <Text style={{ flex: 3, textAlign: "center", ...fonts.regular }}>
              18.5
            </Text>
            <View style={{ flex: 3.5 }} />
            <Text style={{ flex: 3, textAlign: "center", ...fonts.regular }}>
              25
            </Text>
            <View style={{ flex: 2 }} />
            <Text style={{ flex: 3, textAlign: "center", ...fonts.regular }}>
              30
            </Text>
            <View style={{ flex: 5 }} />
          </View>
          <TouchableOpacity
            onPress={() => this.updateProfile()}
            style={{
              alignSelf: "center",
              backgroundColor: "#5DBE66",
              borderRadius: 20,
              marginTop: 20
            }}
          >
            <Text
              style={{
                color: staticColors.white,
                fontSize: 16,
                paddingHorizontal: 30,
                paddingVertical: 10,

                ...fonts.bold
              }}
            >
              Simpan
            </Text>
          </TouchableOpacity>
        </>
      );
    } else {
      bmiContainer = (
        <Text
          style={{
            color: themeColors.darkestPrimary,
            fontSize: 14,

            ...fonts.regular
          }}
        >
          Silakan lengkapi tinggi & berat badan terlebih dahulu
        </Text>
      );
    }

    return (
      <ScrollView style={{ backgroundColor: staticColors.white, flex: 1 }}>
        <View style={{ backgroundColor: themeColors.primary }}>
          <View
            style={{
              alignItems: "center",
              flexDirection: "row",
              paddingHorizontal: 30,
              paddingVertical: 15
            }}
          >
            <PatientAvatar cardNumber={cardNumber} gender={gender} />
            <Text
              style={{
                color: staticColors.white,
                fontSize: 24,
                marginStart: 15,

                ...fonts.bold
              }}
            >
              Profil Medis
            </Text>
          </View>
          <View
            style={{
              backgroundColor: staticColors.white,
              borderTopEndRadius: 40,
              borderTopStartRadius: 40,
              height: 40
            }}
          />
        </View>
        <View style={{ paddingHorizontal: 30 }}>
          <Text
            style={{
              color: themeColors.darkestPrimary,
              fontSize: 24,

              ...fonts.bold
            }}
          >
            {fullName}
          </Text>
          <Text
            style={{
              color: themeColors.darkestPrimary,
              fontSize: 18,
              marginBottom: 20,

              ...fonts.regular
            }}
          >
            {`${genderName}, ${ageText} Tahun`}
          </Text>
          <Text
            style={{
              color: themeColors.darkestPrimary,
              fontSize: 18,

              ...fonts.regular
            }}
          >
            Sebelum memulai, mohon untuk dapat melengkapi informasi berikut:
          </Text>
          <Text
            style={{
              color: themeColors.darkestPrimary,
              fontSize: 18,
              marginTop: 20,

              ...fonts.bold
            }}
          >
            Tinggi Badan:
          </Text>
          <TouchableOpacity
            onPress={() => this.setState({ heightSelectorVisible: true })}
            style={{
              alignItems: "center",
              flexDirection: "row",
              marginTop: 10
            }}
          >
            <TextInput
              editable={false}
              placeholder="Input tinggi badan"
              style={{
                backgroundColor: "#F1F1F1",
                borderRadius: 10,
                paddingHorizontal: 16,
                paddingVertical: 8
              }}
              value={height ? `${height} cm` : ""}
            />
            <Image
              source={require("../assets/icons/baseline_edit_black_18dp.png")}
              style={{ marginStart: 10, padding: 10 }}
            />
            <Modal isVisible={heightSelectorVisible} useNativeDriver={true}>
              <View
                style={{
                  backgroundColor: staticColors.white,
                  borderRadius: 40,
                  padding: 30
                }}
              >
                <Text
                  style={{
                    alignSelf: "center",
                    color: themeColors.darkestPrimary,
                    fontSize: 20,
                    marginBottom: 20,

                    ...fonts.bold
                  }}
                >
                  Pilih Tinggi
                </Text>
                <View style={{ flexDirection: "row" }}>
                  <WheelPicker
                    data={_.range(30, 251).map(i => i.toString())}
                    initPosition={heightInteger ? heightInteger - 30 : 130}
                    onItemSelected={selectedItem => {
                      this.setState({
                        temporaryHeightInteger: selectedItem + 30
                      })
                    }
                    }
                    selectedItem={
                      temporaryHeightInteger
                        ? temporaryHeightInteger - 30
                        : heightInteger
                        ? heightInteger - 30
                        : 130
                    }
                  />
                  <WheelPicker
                    data={_.range(0, 10).map(i => i.toString())}
                    initPosition={heightDecimal ? heightDecimal : 0}
                    onItemSelected={selectedItem =>
                      this.setState({ temporaryHeightDecimal: selectedItem })
                    }
                    selectedItem={
                      temporaryHeightDecimal
                        ? temporaryHeightDecimal
                        : heightDecimal
                        ? heightDecimal
                        : 0
                    }
                    style={{ width: 100 }}
                  />
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between"
                  }}
                >
                  <TouchableOpacity
                    onPress={() =>
                      this.setState({
                        heightSelectorVisible: false,
                        temporaryHeightDecimal: null,
                        temporaryHeightInteger: null
                      })
                    }
                    style={{ backgroundColor: "#E64F4F", borderRadius: 20 }}
                  >
                    <Text
                      style={{
                        color: staticColors.white,
                        fontSize: 16,
                        paddingHorizontal: 30,
                        paddingVertical: 10,

                        ...fonts.bold
                      }}
                    >
                      Batal
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => {
                      const defaultHeightInteger = 160;
                      const defaultHeightDecimal = 0;
                      this.setState({
                        heightDecimal:
                          temporaryHeightDecimal === 0
                            ? 0
                            : temporaryHeightDecimal ||
                              heightDecimal ||
                              defaultHeightDecimal,
                        heightInteger:
                          temporaryHeightInteger ||
                          heightInteger ||
                          defaultHeightInteger,
                        heightSelectorVisible: false,
                        temporaryHeightDecimal: null,
                        temporaryHeightInteger: null,
                      });
                    }
                    }
                    style={{ backgroundColor: "#5DBE66", borderRadius: 20 }}
                  >
                    <Text
                      style={{
                        color: staticColors.white,
                        fontSize: 16,
                        paddingHorizontal: 30,
                        paddingVertical: 10,

                        ...fonts.bold
                      }}
                    >
                      Pilih
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </Modal>
          </TouchableOpacity>
          <Text
            style={{
              color: themeColors.darkestPrimary,
              fontSize: 18,
              marginTop: 20,

              ...fonts.bold
            }}
          >
            Berat Badan:
          </Text>
          <TouchableOpacity
            onPress={() => this.setState({ weightSelectorVisible: true })}
            style={{
              alignItems: "center",
              flexDirection: "row",
              marginTop: 10
            }}
          >
            <TextInput
              editable={false}
              placeholder="Input berat badan"
              style={{
                backgroundColor: "#F1F1F1",
                borderRadius: 10,
                paddingHorizontal: 16,
                paddingVertical: 8
              }}
              value={weight ? `${weight} kg` : ""}
            />
            <Image
              source={require("../assets/icons/baseline_edit_black_18dp.png")}
              style={{ marginStart: 10, padding: 10 }}
            />
            <Modal isVisible={weightSelectorVisible} useNativeDriver={true}>
              <View
                style={{
                  backgroundColor: staticColors.white,
                  borderRadius: 40,
                  padding: 30
                }}
              >
                <Text
                  style={{
                    alignSelf: "center",
                    color: themeColors.darkestPrimary,
                    fontSize: 20,
                    marginBottom: 20,

                    ...fonts.bold
                  }}
                >
                  Pilih Berat
                </Text>
                <View style={{ flexDirection: "row" }}>
                  <WheelPicker
                    data={_.range(1, 251).map(i => i.toString())}
                    initPosition={weightInteger ? weightInteger - 1 : 69}
                    onItemSelected={selectedItem =>
                      this.setState({
                        temporaryWeightInteger: selectedItem + 1
                      })
                    }
                    selectedItem={
                      temporaryWeightInteger
                        ? temporaryWeightInteger - 1
                        : weightInteger
                        ? weightInteger - 1
                        : 69
                    }
                  />
                  <WheelPicker
                    data={_.range(0, 10).map(i => i.toString())}
                    initPosition={weightDecimal ? weightDecimal : 0}
                    onItemSelected={selectedItem =>
                      this.setState({ temporaryWeightDecimal: selectedItem })
                    }
                    selectedItem={
                      temporaryWeightDecimal
                        ? temporaryWeightDecimal
                        : weightDecimal
                        ? weightDecimal
                        : 0
                    }
                    style={{ width: 100 }}
                  />
                </View>
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between"
                  }}
                >
                  <TouchableOpacity
                    onPress={() => {
                        this.setState({
                          temporaryWeightDecimal: null,
                          temporaryWeightInteger: null,
                          weightSelectorVisible: false
                        })
                      }
                    }
                    style={{ backgroundColor: "#E64F4F", borderRadius: 20 }}
                  >
                    <Text
                      style={{
                        color: staticColors.white,
                        fontSize: 16,
                        paddingHorizontal: 30,
                        paddingVertical: 10,

                        ...fonts.bold
                      }}
                    >
                      Batal
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => {
                      const defaultWeightDecimal = 0;
                      const defaultWeightInteger = 70;

                      this.setState({
                        temporaryWeightDecimal: null,
                        temporaryWeightInteger: null,
                        weightDecimal:
                        temporaryWeightDecimal === 0
                            ? 0
                            : temporaryWeightDecimal ||
                              weightDecimal ||
                              defaultWeightDecimal,
                        weightInteger:
                          temporaryWeightInteger ||
                          weightInteger ||
                          defaultWeightInteger,
                        weightSelectorVisible: false,
                      });
                      }
                    }
                    style={{ backgroundColor: "#5DBE66", borderRadius: 20 }}
                  >
                    <Text
                      style={{
                        color: staticColors.white,
                        fontSize: 16,
                        paddingHorizontal: 30,
                        paddingVertical: 10,

                        ...fonts.bold
                      }}
                    >
                      Pilih
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </Modal>
          </TouchableOpacity>
          <Text
            style={{
              color: themeColors.darkestPrimary,
              fontSize: 18,
              marginTop: 20,

              ...fonts.bold
            }}
          >
            BMI:
          </Text>

          {bmiContainer}
        </View>
      </ScrollView>
    );
  }
}

export default connect(state => ({
  themeColors: state.themeColors,
  token: state.token
}))(MedicalScreen);
